export const USER_PREFERENCE = {
  INBOX_DISMISSED: 'InboxDismissed',
  MYINFO_PROMPT_DISABLED: 'MyInfoPromptDisabled',
} as const;
